let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("16rPB")).then(() => parcelRequire('bY3rp'));